var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo Container"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#217345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "New - Logo",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2168 8.54035L22.8957 7.86147C25.2869 9.88738 26.6673 12.8634 26.6673 16C26.6673 21.8871 21.8877 26.6667 16.0006 26.6667C10.1135 26.6667 5.33398 21.8871 5.33398 16C5.33398 10.1129 10.1136 5.33334 16.0006 5.33334C17.684 5.33334 19.3434 5.73173 20.8432 6.49594L20.8047 6.57159L18.0828 9.29344C17.4107 9.08477 16.7089 8.97765 16.0006 8.97765C12.1249 8.97765 8.97829 12.1243 8.97829 16C8.97829 19.8758 12.1249 23.0224 16.0006 23.0224C19.8764 23.0224 23.023 19.8757 23.023 16C23.023 15.0878 22.8456 14.1961 22.5119 13.37L16.0012 19.8807L11.7487 15.6282L14.3107 13.0661L16.0012 14.7566L22.214 8.54374L22.2168 8.54035Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e9d5b2f75a4b0cf87f86fc37dd785f46.svg";
export { ForwardRef as ReactComponent };